import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";

const AddHtmlDocFile = () => {
  const navigate = useNavigate();
  const { id, name } = useParams(); // Get the HTML document ID from the URL

  // State to hold form data
  const [formData, setFormData] = useState({
    HtmlDocId: id,
    Remark: "",
    Active: true,
    Name: name,
    File: null,
  });

  // State to hold API response or error
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(null); // 'success' | 'error'

  // State for selected name from select box
  const [selectedName, setSelectedName] = useState("");

  // New state for upload mode: 'single' or 'multiple'
  const [uploadMode, setUploadMode] = useState("single");
  const [selectedFiles, setSelectedFiles] = useState([]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "File") {
      const fileList = Array.from(files);
      setSelectedFiles(fileList);
      if (uploadMode === "single" && fileList.length > 0) {
        setFormData((prevData) => ({
          ...prevData,
          File: fileList[0],
        }));
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the form from refreshing the page

    // Validation
    if (!formData.Remark || selectedFiles.length === 0 || (uploadMode === "single" && !selectedName)) {
      setMessage("Please fill in all required fields.");
      setMessageType("error");
      return;
    }

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const filesToUpload = uploadMode === "single" ? [selectedFiles[0]] : selectedFiles;
    let successCount = 0;
    let lastError = "";

    for (let i = 0; i < filesToUpload.length; i++) {
      const file = filesToUpload[i];

      // Update progress message
      setMessage(`Uploading file ${i + 1} of ${filesToUpload.length}: ${file.name}`);
      setMessageType("success");

      const data = new FormData();
      data.append("HtmlDocId", formData.HtmlDocId);
      data.append("Remark", formData.Remark);
      data.append("Active", formData.Active);
      // If multiple, use filename as name; if single, use selectedName from dropdown
      data.append("Name", uploadMode === "single" ? selectedName : file.name);
      data.append("File", file);

      try {
        const response = await axios.post(
          'https://api.dqr-display-tms.bonrix.in/api/HtmlDocInfoOperation/Insert',
          data,
          {
            headers: {
              "X-Authorization": token,
              UserId: userid,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const resp = response && response.data;
        const isSuccess =
          (resp && resp.isresponse === true) ||
          (resp && typeof resp.responsestatus === "string" && resp.responsestatus.toUpperCase() === "SUCCESS");

        if (isSuccess) {
          successCount++;
        } else {
          lastError = (resp && (resp.errormsg || resp.message || resp.Message || resp.responsestatus)) || "Unknown error";
        }
      } catch (error) {
        const errData = error && error.response && error.response.data;
        lastError = (errData && (errData.errormsg || errData.message || errData.Message || errData.responsestatus)) || (error && error.message) || "Failed to upload.";
      }
    }

    if (successCount === filesToUpload.length) {
      setMessage("All files uploaded successfully!");
      setMessageType("success");
      setTimeout(() => {
        navigate(`/showhtmldoc/${id}/${name}`);
      }, 3000);
    } else if (successCount > 0) {
      setMessage(`Uploaded ${successCount} of ${filesToUpload.length} files. Last error: ${lastError}`);
      setMessageType("error");
    } else {
      setMessage(`Failed to upload files. Error: ${lastError}`);
      setMessageType("error");
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper add-html-doc-file-page">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info elevated-card">
                    <div className="card-header">
                      <h3 className="card-title">Add HTML Document File</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group"></div>
                            <div className="form-group">
                              <label>Upload Mode</label>
                              <div className="d-flex align-items-center">
                                <div className="form-check mr-3">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="uploadMode"
                                    id="singleMode"
                                    value="single"
                                    checked={uploadMode === "single"}
                                    onChange={(e) => setUploadMode(e.target.value)}
                                  />
                                  <label className="form-check-label" htmlFor="singleMode">
                                    Single File
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="uploadMode"
                                    id="multipleMode"
                                    value="multiple"
                                    checked={uploadMode === "multiple"}
                                    onChange={(e) => setUploadMode(e.target.value)}
                                  />
                                  <label className="form-check-label" htmlFor="multipleMode">
                                    Multiple Files
                                  </label>
                                </div>
                              </div>
                            </div>

                            {uploadMode === "single" && (
                              <div className="form-group">
                                <label>Select Name</label>
                                <select
                                  className="form-control input-lg"
                                  value={selectedName}
                                  onChange={(e) => setSelectedName(e.target.value)}
                                  name="Name"
                                >
                                  <option value="">-- Select Name --</option>
                                  <option value="WelcomeScreen">WelcomeScreen</option>
                                  <option value="DisplayTotalScreen">DisplayTotalScreen</option>
                                  <option value="DisplayQRCodeScreen">DisplayQRCodeScreen</option>
                                  <option value="DisplaySuccessQRCodeScreen">DisplaySuccessQRCodeScreen</option>
                                  <option value="DisplayFailQRCodeScreen">DisplayFailQRCodeScreen</option>
                                  <option value="DisplayPendingQRCodeScreen">DisplayPendingQRCodeScreen</option>
                                  <option value="DisplayCancelQRCodeScreen">DisplayCancelQRCodeScreen</option>
                                  <option value="SingleItemInfo">SingleItemInfo</option>
                                  <option value="SubmitBill">SubmitBill</option>
                                  <option value="dqr11">DQR 11</option>
                                </select>
                              </div>
                            )}
                            <div className="form-group">
                              <label>File Description</label>
                              <input
                                type="text"
                                className="form-control input-lg"
                                value={formData.Remark}
                                onChange={handleChange}
                                placeholder="Enter file description..."
                                name="Remark"
                              />
                            </div>
                            <div className="form-group">
                              <label>Upload File{uploadMode === "multiple" ? "s" : ""}</label>
                              <input
                                type="file"
                                className="form-control input-lg"
                                onChange={handleChange}
                                name="File"
                                accept="image/*,.html,text/html"
                                multiple={uploadMode === "multiple"}
                              />
                              {selectedFiles.length > 0 && (
                                <small className="form-text text-muted">
                                  {selectedFiles.length} file(s) selected: {selectedFiles.map(f => f.name).join(", ")}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info btn-lg"
                          >
                            Add File
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className="page-messages">
        {message && messageType === "success" ? <SuccessMessage message={message} /> : ""}
        {message && messageType === "error" ? <FailedMessage message={message} /> : ""}
      </div>
    </>
  );
};

export default AddHtmlDocFile;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}